var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-bottom-margin"},[_c('h1',{staticClass:"header-style"},[_vm._v("\n    My Projects\n  ")]),_c('p',{staticClass:"subheader-style"},[_vm._v("\n    List of all projects under this organization.\n  ")]),_c('organization-projects')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }